module.exports = __webpack_public_path__ + "static/img/map@2x.203ed5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/map@2x.png
// module id = AzFG
// module chunks = 1